import { createContext, useContext, type ReactNode } from "react";
import { useParams } from "react-router-dom";
import { useScenarioRetry } from "@hooks/game/activity/session/use-scenario-retry";

const ScenarioRetryContext = createContext<ReturnType<typeof useScenarioRetry> | null>(null);

export const ScenarioRetryProvider = ({ children, userId }: { children: ReactNode; userId: string | null }) => {
  const { sessionId } = useParams();
  const retry = useScenarioRetry(sessionId, userId);
  return <ScenarioRetryContext.Provider value={retry}>{children}</ScenarioRetryContext.Provider>;
};

export const useOptionalScenarioRetryContext = () => useContext(ScenarioRetryContext);

export const useScenarioRetryContext = () => {
  const context = useContext(ScenarioRetryContext);
  if (!context) throw new Error("useScenarioRetryContext must be used within ScenarioRetryProvider");
  return context;
};
